import * as React from 'react';
import './ui.css';

/*
 * Skeleton — a shimmering placeholder block, sized by the caller. Use while
 * first-load data is in flight so a pending fetch doesn't read as an empty
 * result ("No open games" before any games have arrived).
 */

interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  radius?: string;
  style?: React.CSSProperties;
}

export const Skeleton: React.FC<SkeletonProps> = ({
  width = '100%',
  height = 16,
  radius = 'var(--radius-sm)',
  style,
}) => <div className="ui-skeleton" style={{ width, height, borderRadius: radius, ...style }} />;

export default Skeleton;
